import SurveyResponsesPieChartCard from './SurveyResponsesPieChartCard';

export default SurveyResponsesPieChartCard;
